import script from "./NoteDetailModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NoteDetailModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__